export default __webpack_public_path__ + "static/media/cloud1.ac8b6bd5.svg";